/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgForm from './OrgForm';
import { editOrg } from '../../../../../../services/organization/Organization';
import { getAllOrg } from '../../../../../../store/reducers/organization/organizationAction';

const OrgEdit = ({  handleClose, selectedOrg }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationName, detailName, detailValue }, { setSubmitting }) => {
        try {
            setSubmitting(true)
            await editOrg({
                organizationName, organizationID: selectedOrg.organizationID, organizationDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Organization was edited successfully');
            handleClose();
            await  dispatch(getAllOrg()).unwrap();
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Edit</Typography>
            <Formik
                initialValues={{
                    organizationName: selectedOrg.organizationName,
                    detailName: selectedOrg.organizationDetails[0].detailName,
                    detailValue: selectedOrg.organizationDetails[0].detailValue,

                }}
                validationSchema={Yup.object().shape({
                    organizationName: Yup.string().min(2).max(40).required('Organization Name is required.')
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >{({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (

                <OrgForm
                    values={values}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    isSubmitting={isSubmitting}
                    handleClose={handleClose}
                    errors={errors}
                    touched={touched}
                />
            )}
            </Formik>
        </>
    )

}

export default OrgEdit;
